import React, { useState, useEffect } from 'react';
import Table from '../../components/Table';
import * as apicall from '../../components/Apicall';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const StateList = () => {
  const [states, setStates] = useState([]);
  const [loadingStates, setLoadingStates] = useState(true);

  const stateHeaders = ['State Name', 'Country Name', 'Active'];


  const getStatesList = async () => {
    try {
      const res = await apicall.get('state/0'); 
      setStates(res.data);
    } catch (e) {
      toast.error(e.message?.replace('Error:', '') || 'An error occurred');
    } finally {
      setLoadingStates(false);
    }
  };

  useEffect(() => {
    getStatesList();
  }, []);

  const statesData = states.map(({ name, country_name, is_active }) => [
    name,
    country_name,
    is_active ? 'Yes' : 'No',
  ]);

  return (
    <div className="container my-3">
   
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="heading ml-2">State</h3>
      </div>
      {loadingStates ? (
        <div>
          <Skeleton height={30} count={5} style={{ marginBottom: '10px' }} />
        </div>
      ) : (
        <Table headers={stateHeaders} data={statesData} pagination={true} recordsCount={10} />
      )}
    </div>
  );
};

export default StateList;